import { useMemo } from 'react';
import { useQuery } from 'react-query';

import { getPartnerBanners } from '@/services/Partner/request';
import { IBanner } from '@/services/Partner/types';

import { useFeatureFlags } from '@/hooks/useFeatureFlags';

const LOCATION = 'HOSTS_PANEL';

export default function useHostHomeBanner() {
  const { featureFlags } = useFeatureFlags();

  const enabled = featureFlags?.ff_enable_host_home_banner;

  const { data, isLoading, isError, error, refetch, isFetching } = useQuery<IBanner[]>(
    ['host-home-banner', LOCATION],
    () => getPartnerBanners(LOCATION),
    {
      enabled,
      staleTime: 1000 * 60 * 15,
      cacheTime: 1000 * 60 * 30,
      refetchOnWindowFocus: false,
    },
  );

  const banner = useMemo(() => (data && data.length > 0 ? data[0] : null), [data]);

  return {
    banner,
    isLoading,
    isError,
    error,
    refetch,
    isFetching,
  };
}
